import { ReactNode, useMemo } from "react";
import { createFastContext } from "../../../../../contexts/createFastContext";
import { IDeliveryType, IUnit, IVessel, TOperation } from "../../../../../util/varibles/interface";

interface IState {
    op?: TOperation
    vessel?: IVessel
    remaining_weight: number
    unit: IUnit;
    deliveryTypes: {
        [key: string]: IDeliveryType
    };
}

const {
    Provider,
    useStore: useEditSubOp,
    setStore: setEditSubOp,
    getStore: getEditSubOp,
    callEvent: callEventEditSubOp
} = createFastContext<IState>({
    remaining_weight: 0,
    unit: {
        id: "",
        unit_id: "",
        fish_amount: 0,
        avg_weight: 0,
        total_weight: 0,
        mortality_risk: false
    },
    deliveryTypes: {}
});

const EditSubOpProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    const { vessel, op } = args;
    const { capacity = 0 } = vessel || {};
    const remaining_weight = useMemo(() => Math.max(capacity - (op?.total_weight || 0), 0), [capacity, op?.total_weight]);

    return <Provider props={{ ...args, remaining_weight }}>
        {children}
    </Provider>;
};


export { callEventEditSubOp, EditSubOpProvider, getEditSubOp, setEditSubOp, useEditSubOp };

